export var SamsungPayButtonTypeEnumsObj = {
    PLAIN: "plain",
};
